import './MenuListPage.less';

export const prefix = 'bm-p-menu-list';

export { default } from './MenuListPage';
